import React from 'react';
import { Translate } from 'react-redux-i18n';

import PropTypes from 'prop-types';
import founderLogoSrc from '../../assets/founder_icons/founder.svg';
import founder2LogoSrc from '../../assets/founder_icons/founder2.svg';
import './FounderLogo.scss';

const baladyUrl = 'https://balady.gov.sa/ar';
const statsUrl = 'https://www.stats.gov.sa/';

const FounderLogo = ({ chosenRegion, hideOnSmallLaptop }) => (
  <div className={`founder-logo ${hideOnSmallLaptop ? 'hide-sm' : ''}`}>
    <div className='founder-logo__container'>
      <a
        className='clear-link'
        target='_blank'
        rel='noopener noreferrer'
        href={baladyUrl}
      >
        <div className={`founder-logo__box ${chosenRegion}`}>
          <img
            className='founder-logo__image'
            alt='founder logo'
            src={founderLogoSrc}
          />
        </div>
      </a>
      <a
        className='clear-link'
        target='_blank'
        rel='noopener noreferrer'
        href={statsUrl}
      >
        <div className={`founder-logo__box ${chosenRegion}`}>
        <img
            className='founder-logo__image'
            alt='founder logo'
            src={founder2LogoSrc}
          />
        </div>
      </a>
    </div>
  </div>
);

export default FounderLogo;

FounderLogo.propTypes = {
  chosenRegion: PropTypes.string,
  hideOnSmallLaptop: PropTypes.bool,
};
